import type { ReactNode } from "react";
import type { Severity } from "../lib/types";

const SEVERITY_STYLES: Record<Severity, string> = {
  high: "bg-rose-50 text-rose-700 border-rose-200",
  medium: "bg-amber-50 text-amber-700 border-amber-200",
  low: "bg-slate-100 text-slate-600 border-slate-200",
  none: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

const SEVERITY_LABEL: Record<Severity, string> = {
  high: "High risk",
  medium: "Medium risk",
  low: "Low risk",
  none: "On track",
};

export function RiskBadge({ severity, count }: { severity: Severity; count?: number }) {
  const label = SEVERITY_LABEL[severity] ?? severity;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${
        SEVERITY_STYLES[severity] ?? SEVERITY_STYLES.none
      }`}
    >
      {label}
      {count ? <span className="opacity-70">· {count}</span> : null}
    </span>
  );
}

export function HoldTag({ code }: { code: string }) {
  return (
    <span className="inline-flex items-center rounded-full border border-rose-200 bg-rose-50 px-2 py-0.5 text-xs font-medium text-rose-700">
      {code}
    </span>
  );
}

export function Field({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-wide text-slate-400">{label}</div>
      <div className="text-sm text-slate-800">{value ?? "—"}</div>
    </div>
  );
}

export function Card({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="rounded-lg border border-slate-200 bg-white">
      <h3 className="border-b border-slate-100 px-4 py-2 text-sm font-semibold text-slate-700">
        {title}
      </h3>
      <div className="p-4">{children}</div>
    </section>
  );
}
